// Constant for media queries:
export const WIDTH = {
    largePhone: 400,
    tablet: 568,
    laptop: 900,
    desktop: 1200,
};
